<a [href]="assetDownloadURL" [download]="assetDownloadLinkData.assetName" *ngIf="assetDownloadLinkData != null; else none" target="_blank"
   (click)="setLink()">Download {{assetDownloadLinkData.assetName}}</a>
   <ng-template #none>
      None
   </ng-template>
   
